import React, { Component } from "react";
import TopImgProfile from "../../Components/Profile/TopImgProfile";
import ProfileOptions from "../../Components/Profile/ProfileOptions";
import Header from "../../Components/MainLayout/Header";

class Profile extends Component {
  render() {
    return (
      <div>
        <Header title="Profile" />
        <TopImgProfile />
        <ProfileOptions />
      </div>
    );
  }
}
export default Profile;
